import script from "./indexOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./indexOrder.vue?vue&type=script&setup=true&lang=js"

import "./indexOrder.vue?vue&type=style&index=0&id=4b287eef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b287eef"]])

export default __exports__